import Loader from "../../components/Loader";
import DialogList from "../dialogs/DialogList";
import Button from "../../components/Button";
import useProblemCard from "./hooks/useProblemCard";

const ProblemCard = () => {
  const {
    onCreateDialog,
    buttonCaption,
    creatingDialog,
    dialogs,
    dialogsLoading,
  } = useProblemCard();

  if (dialogsLoading) {
    return (
      <div style={{ margin: "auto" }}>
        <Loader small />
      </div>
    );
  }

  return (
    <div>
      <h2>Problems</h2>
      <br />
      <DialogList {...{ dialogs }} />
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Button important onClick={onCreateDialog} loader={creatingDialog}>
          {buttonCaption}
        </Button>
      </div>
    </div>
  );
};

export default ProblemCard;
